import React from 'react';
import { useAppSelector } from '@/store/hooks';
import { selectModalState, useModalClose } from '@/features/modals/modalSlice';
import { Backdrop } from './ModalSystem.styles';

export const ModalSystem = () => {
  const modalState = useAppSelector(selectModalState);
  const handleClose = useModalClose();

  return <Backdrop onClick={handleClose} data-modal-state={modalState} />;
};
